import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// jquery
declare const $: any;

@Injectable({
  providedIn: 'root'
})
export class NotificacaoService {
  atualizacaoProgresso: BehaviorSubject<any>;
  baixaTxid: BehaviorSubject<any>;
  novoICFeedItem: BehaviorSubject<any>;

  constructor() {
    this.atualizacaoProgresso = new BehaviorSubject(undefined);
    this.baixaTxid = new BehaviorSubject(undefined);
    this.novoICFeedItem = new BehaviorSubject(undefined);
  }

  // exibe mensagem de sucesso
  sucesso(mensagem) {
    this.showNotification('top', 'right', 'success', mensagem);
  }

  // exibe mensagem de erro
  erro(erro) {
    if (!erro) {
      return;
    }

    if (erro.status && (erro.status === 401 || erro.status === 403 || erro.status === 404)) {
      return;
    }

    if (typeof erro === 'string') {
      this.showNotification('top', 'right', 'danger', erro);
    } else if (erro.error && erro.error.errors) {
      this.showNotification('top', 'right', 'danger', erro.error.errors.map(p => p.reason).join('<br>'));
    } else {
      this.showNotification('top', 'right', 'danger', erro.error && erro.error.Message ? erro.error.Message :
        erro.error && erro.error.message ? erro.error.message :
          erro.error && erro.error.error_description ? erro.error.error_description :
            erro.error && erro.error[''] ? erro.error[''][0] : erro.error ? erro.error : 'ERRO');
    }
  }

  // exibe mensagem de erro
  aviso(erro) {
    if (!erro) {
      return;
    }

    if (typeof erro === 'string') {
      this.showNotification('top', 'right', 'warning', erro);
    } else {
      this.showNotification('top', 'right', 'warning', erro.error && erro.error.Message ? erro.error.Message :
        erro.error && erro.error.error_description ? erro.error.error_description :
          erro.error && erro.error[''] ? erro.error[''][0] : erro.error ? erro.error : 'ERRO');
    }
  }

  erroMSG(erro: string) {
    this.showNotification('top', 'right', 'danger', erro);
  }

  private showNotification(from: any, align: any, color: string, mensagem: string) {
    const type = ['', 'info', 'success', 'warning', 'danger', 'rose', 'primary'];

    // const color = Math.floor((Math.random() * 6) + 1);

    $.notify({
      icon: 'notifications',
      message: mensagem
    }, {
      type: color,
      timer: 3000,
      placement: {
        from,
        align
      },
      template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-raised-button type="button" aria-hidden="true" class="close" data-notify="dismiss"> ' +
        '<i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" ' +
        ' aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
}
